import { http } from './http';

import Player from '../models/player';
import ViewData from '../models/view';
import { fillPlayerNames } from './set';

function cmpRatio(a: Player, b: Player): number {
  if (a.ratio === null) return 1;
  if (b.ratio === null) return -1;
  if (a.ratio === undefined) return 1;
  if (b.ratio === undefined) return -1;
  return b.ratio - a.ratio;
}

function playerName(id: number, playerData: Player[]): string {
  const player = playerData.find((p) => p.id === id);
  return player ? player.lastname + ' ' + player.name : 'Neznámy hráč';
}

async function getViewData(): Promise<ViewData> {
  // /view is public, but using http is fine (it will just attach Authorization if present)
  const response = await http.get<ViewData>('/view/current/get-data');
  const data = response.data;

  // Adjust marathon data:
  // - convert dates to Date objects
  if (data.marathon.startDate) data.marathon.startDate = new Date(data.marathon.startDate);
  if (data.marathon.endDate) data.marathon.endDate = new Date(data.marathon.endDate);

  // Adjust player data:
  // - for players with less than 10 sets, set ratio to undefined
  // - sort players by ratio
  data.players.forEach((p) => {
    if (p.setsPlayed !== undefined && p.setsPlayed < 10) p.ratio = undefined;
  });
  data.players.sort(cmpRatio);

  // Adjust set data:
  // - replace player ids by names
  fillPlayerNames(data.sets, data.players);

  return data;
}

export { getViewData, playerName };
